function feetToInches(feet) {
    return feet * 12;
}
function getRollCount(MaxNumDrops, DropLengthIn, Availability, ThisSizeOnly) {
    var SRoll = 15;
    var MRoll = 30;
    var LRoll = 45;
    var Ret_code = 0;
    Availability = Availability.toUpperCase();
    ThisSizeOnly = ThisSizeOnly.toUpperCase();

    if (Availability.indexOf('S') == -1) {
        SRoll = 0;
    }

    if (Availability.indexOf('D') == -1) {
        MRoll = 0;
    }
  
    if (Availability.indexOf('T') == -1) {
        LRoll = 0;
    }

    var sizelist = getRollCountsCore(MaxNumDrops, DropLengthIn, LRoll, MRoll, SRoll);
    if (ThisSizeOnly == 'S') {
        Ret_code = sizelist[2];
    }

    if (ThisSizeOnly == 'D') {
        Ret_code = sizelist[1];
    }

    if (ThisSizeOnly == 'T') {
        Ret_code = sizelist[0];
    }

    if (ThisSizeOnly == 'TOTAL') {
        Ret_code = sizelist[2] * SRoll / 15 + sizelist[1] * MRoll / 15 + sizelist[0] * LRoll / 15;
    }

    return Ret_code;
}
function calculateHandscreened() {
    let widthofground = parseFloat(document.querySelector('#width-of-ground').value) || 0;
    let patterReapeat = parseFloat(document.querySelector('#pattern-repeat').value) || 0;
    let matchFActor = parseFloat(document.querySelector('#match-factor').value) || 0;
    let RollsizeAvailable = document.querySelector('#roll-size').value;
    let counterrorH = 0;
    let wallGroups = {}; // Store widths grouped by height
    
    const allCustomWall = document.querySelectorAll('div.custom-walls-hs');
    let wallInfo = "";

  

      console.log('width of the ground', widthofground)
        console.log('Pattern repeat', patterReapeat)
        console.log('matchFActor', matchFActor)

  

    allCustomWall.forEach((wallinputs, index) => {
      console.log(wallinputs.querySelector('input#width-feet'))
        let wallft_width = parseFloat(wallinputs.querySelector('input#width-feet').value) || 0;
        let wallin_width = parseFloat(wallinputs.querySelector('input#width-inches').value) || 0;
        let combinewidth = feetToInches(wallft_width) + wallin_width;
    
        let wallft_height = parseFloat(wallinputs.querySelector('input#height-feet').value) || 0;
        let wallin_height = parseFloat(wallinputs.querySelector('input#height-inches').value) || 0;
        let combineheight = feetToInches(wallft_height) + wallin_height;
    
        if (combineheight > 180) {
            document.querySelector("#height_error").style.display = "block";
            document.querySelector(".product-form__submit").setAttribute("disabled", true);
            counterrorH++;
        }

        if (combineheight == 0 || combinewidth == 0) {
            return;
        }

        if (!wallGroups[combineheight]) {
            wallGroups[combineheight] = 0;
        }
        wallGroups[combineheight] += combinewidth;

        let txt_separator = index > 0 ? " | " : "";
        wallInfo += `${txt_separator}Wall ${index + 1} = Width: ${wallft_width}' - ${wallin_width}" L x ${wallft_height}' - ${wallin_height}" H`;
    });

    document.querySelector('#wall-info').value = wallInfo;
     
    if (Object.keys(wallGroups).length === 0) {
        document.querySelector("#height_error").style.display = "none";
        document.querySelector(".product-form__submit").setAttribute("disabled", true);
        return;
    }

  
    document.querySelector(".product-form__submit").removeAttribute('disabled');
    document.querySelector("#height_error").style.display = "none";
    if(counterrorH > 0){
      document.querySelector(".product-form__submit").setAttribute('disabled', 'disabled');
      document.querySelector("#height_error").style.display = "block";
    }
    let totalRollsForWall = 0;
    
    for (let height in wallGroups) {
        let wall_width = wallGroups[height];
        let numOfDrops = Math.ceil(wall_width / widthofground);
        let dropLength = parseFloat(height) + (patterReapeat * matchFActor);

        console.log('w of drops', dropLength)
        console.log('numofdrops', numOfDrops)
      
          const dropsPerSingle = Math.floor(180 / dropLength);
          const dropsPerDouble = Math.floor(360 / dropLength);
          const dropsPerTriple = Math.floor(540 / dropLength)
      

       const numberOfSingleRolls = getRollCount(numOfDrops, dropLength, RollsizeAvailable, 'S');
        const numberOfDoubleRolls = getRollCount(numOfDrops, dropLength, RollsizeAvailable, 'D');
        const numberOfTripleRolls = getRollCount(numOfDrops, dropLength, RollsizeAvailable, 'T');

        let rollsForHeight = getRollCount(numOfDrops, dropLength, RollsizeAvailable, 'TOTAL');
      console.log(rollsForHeight)
        totalRollsForWall += rollsForHeight;
    }

    document.querySelector('input[name="quantity"]').value = totalRollsForWall;
}


var getRollCountsCore = function(MaxNumDrops, DropLengthIn, L_RollLengthFt, M_RollLengthFt, S_RollLengthFt) {
    var Num_L_Rolls = 0;
    var Num_M_Rolls = 0;
    var Num_S_Rolls = 0;

    var RollLengths = getYieldsAll(DropLengthIn, L_RollLengthFt, M_RollLengthFt, S_RollLengthFt);

    L_RollLengthFt = (RollLengths[0] > 0) ? L_RollLengthFt : 0;
    M_RollLengthFt = (RollLengths[1] > 0) ? M_RollLengthFt : 0;

    if (DropLengthIn > (M_RollLengthFt * 12)) {
        M_RollLengthFt = 0;
    }

    if (DropLengthIn > (S_RollLengthFt * 12)) {
        S_RollLengthFt = 0;
    }

    var RollsLeftToAllocate = MaxNumDrops;

    if ((RollsLeftToAllocate * DropLengthIn) > (M_RollLengthFt * 12)) {
        if ((RollsLeftToAllocate * DropLengthIn) > (S_RollLengthFt * 12 * 2)) {
            if (RollsLeftToAllocate > 0 && L_RollLengthFt > 0) {
                SoFarRoll = getRollCountAndLeftovers(RollsLeftToAllocate, DropLengthIn, L_RollLengthFt);
                Num_L_Rolls = SoFarRoll[0];
                RollsLeftToAllocate = SoFarRoll[1]; 
            }
        }
    }

    if ((RollsLeftToAllocate * DropLengthIn) > (S_RollLengthFt * 12)) {
        if (RollsLeftToAllocate > 0 && M_RollLengthFt > 0) {
            SoFarRoll = getRollCountAndLeftovers(RollsLeftToAllocate, DropLengthIn, M_RollLengthFt);
            Num_M_Rolls = SoFarRoll[0];
            RollsLeftToAllocate = SoFarRoll[1];
        }
    }

    if (RollsLeftToAllocate > 0 && S_RollLengthFt > 0) {
        SoFarRoll = getRollCountAndLeftovers(RollsLeftToAllocate, DropLengthIn, S_RollLengthFt);
        Num_S_Rolls = SoFarRoll[0];
        RollsLeftToAllocate = SoFarRoll[1];
    }
  
    if (RollsLeftToAllocate > 0) {
        if (S_RollLengthFt > 0) {
            Num_S_Rolls++;
        } else if (M_RollLengthFt > 0) {
            Num_M_Rolls++;
        } else if (L_RollLengthFt > 0) {
            Num_L_Rolls++;
        }
    }

    return [Num_L_Rolls, Num_M_Rolls, Num_S_Rolls];
}

var getYieldsAll = function(DropLengthIn, L_RollLengthFt, M_RollLengthFt, S_RollLengthFt) {
    L_NumDropsPerRoll = parseInt(L_RollLengthFt * 12 / DropLengthIn);
    M_NumDropsPerRoll = parseInt(M_RollLengthFt * 12 / DropLengthIn);
    S_NumDropsPerRoll = parseInt(S_RollLengthFt * 12 / DropLengthIn);
   
    if (L_NumDropsPerRoll == M_NumDropsPerRoll) {
        L_NumDropsPerRoll=0;
    }

    if (M_NumDropsPerRoll == S_NumDropsPerRoll) {
        M_NumDropsPerRoll=0;
    }

    return [L_NumDropsPerRoll, M_NumDropsPerRoll, S_NumDropsPerRoll];
}

var getRollCountAndLeftovers = function(MaxNumDrops, DropLengthIn, RollLengthFt) {
    var RollLengthInches = RollLengthFt * 12;
    var NumDropsPerRoll = parseInt(RollLengthInches / DropLengthIn);
    var NumRolls = -1;
    var UnallocatedDrops=-1;

    if (NumDropsPerRoll > 0) {
        NumRolls = MaxNumDrops / NumDropsPerRoll;
        
        if (NumRolls >= 1) {
            NumRolls = parseInt(NumRolls)
        }
        else if (NumRolls > 0) {
            NumRolls = 1;
        }

        UnallocatedDrops = MaxNumDrops - (NumRolls * NumDropsPerRoll);

        if (UnallocatedDrops < 0) {
            UnallocatedDrops = 0;
        }
    }

    return [NumRolls, UnallocatedDrops];
};


function calculateDigital() {
    // --------------------------------------------------------
    // Get values
    // --------------------------------------------------------
      
     let wall_width = 0;
     let widthofground = parseFloat(document.querySelector('#width-of-ground').value) || 0; 
     const allCustomWall = document.querySelectorAll('div.custom-walls-dg');
      let wallInfo = ""                         
      allCustomWall.forEach((wallinputs, index) => {
          let wallft_width = parseFloat(wallinputs.querySelector('input#width-feet').value) || 0;
          let wallin_width = parseFloat(wallinputs.querySelector('input#width-inches').value) || 0;
          let combinewidth = feetToInches(wallft_width) + wallin_width;
        
          
          
         
            let txt_separator = "";
                if(index > 0){
                  txt_separator = " | "
                }
                wallInfo = wallInfo + `${txt_separator}Wall ${index + 1} = Width: ${wallft_width}' - ${wallin_width}" L x ${widthofground}' - ${0}" H`
         if(combinewidth == 0){
           document.querySelector('input[name="quantity"]').value = 0;
            return;
         }else{
          wall_width += combinewidth;
         }
        
        });
                     
      document.querySelector('#wall-info').value = wallInfo;
        let bleed = 4;
         
         
          
        let total_rolls_wall = Math.ceil((wall_width + bleed) / widthofground);
  
        if(total_rolls_wall == 0){
           document.querySelector(".product-form__submit").setAttribute("disabled", true);
           document.querySelector('input[name="quantity"]').value = 0;
          return;
        }else{
           document.querySelector(".product-form__submit").removeAttribute('disabled');
            document.querySelector('input[name="quantity"]').value = total_rolls_wall;
        }
    

    /* checkIfWallHeightExceedsRollHeight(walls, 'pdg_size');
          function checkIfWallHeightExceedsRollHeight(walls, sizeFieldName) {
          const $selectedOptionRadio = $('[name="item_options[' + sizeFieldName + ']"]:checked');
          const $selectedOptionUnits = $selectedOptionRadio.siblings('.units');
          const rollHeight = $selectedOptionUnits.data('rollLength');
      
          if (walls.find(function (wall) {
              return !!rollHeight && wall.height > (Number(rollHeight) * 12);
          })) {
              $('.wall-height-exceeds-roll-height-notice').show();
          } else {
              $('.wall-height-exceeds-roll-height-notice').hide();
          }
      };
    */
    

   
}




document.querySelector('input[name="quantity"]').addEventListener("change", checkvalue);

function checkvalue() {
  let qtt_val = document.querySelector('input[name="quantity"]');
  if(qtt_val > 0){
     document.querySelector(".product-form__submit").removeAttribute('disabled');
  }
}



function calculateEZPapes() {
   
    // --------------------------------------------------------
    // Get values
    // --------------------------------------------------------


    const widthOfGround = parseFloat(document.querySelector('#width-of-ground').value) || 0;
    const patternRepeat = parseFloat(document.querySelector('#pattern-repeat').value) || 0;
    const matchFactor = parseFloat(document.querySelector('#match-factor').value) || 0;
    
  
    // --------------------------------------------------------
    // Calculate Rolls
    // --------------------------------------------------------

    let totalRollsForAllWalls = 0;
  
  const allCustomWall = document.querySelectorAll('div.custom-walls-rem');
    allCustomWall.forEach(function (wall, wallIndex) {
         let counterrorH = 0;
          let wallft_width = parseFloat(wall.querySelector('input#width-feet').value) || 0;
          let wallin_width = parseFloat(wall.querySelector('input#width-inches').value) || 0;
          let combinewidth = feetToInches(wallft_width) + wallin_width;
      
          let wallft_height = parseFloat(wall.querySelector('input#height-feet').value) || 0;
          let wallin_height = parseFloat(wall.querySelector('input#height-inches').value) || 0;
          let combineheight = feetToInches(wallft_height) + wallin_height;

        const wallWidth = combinewidth;
        const wallHeight = combineheight;
      

          if(combineheight > 120){
              document.querySelector("#height_error").style.display = "block";
              document.querySelector(".product-form__submit").setAttribute("disabled", true);
              counterrorH = (counterrorH + 1);
            }

      
        if (wallWidth === 0 || wallHeight === 0) {
           document.querySelector('input[name="quantity"]').value = 0;
            return;
        }

        const numberOfDrops = Math.ceil(wallWidth / widthOfGround);
        const lengthOfDrop = wallHeight + (patternRepeat * matchFactor);
        let dropsPerRoll = null;

        if (widthOfGround === 24) {
            dropsPerRoll = Math.floor(252 / lengthOfDrop);
        } else {
            dropsPerRoll = lengthOfDrop > 58 ? 1 : Math.floor(126 / lengthOfDrop);
        }

       if(counterrorH > 0 ){
          document.querySelector("#height_error").style.display = "none";
          document.querySelector(".product-form__submit").removeAttribute("disabled");
      }else{
        const totalRollsForWall = Math.ceil(numberOfDrops / dropsPerRoll);

        console.log('Handscreened wall: ' + (wallIndex + 1));
        console.log('Wall width: ' + wallWidth);
        console.log('Wall height: ' + wallHeight);
        console.log('Width of ground: ' + widthOfGround);
        console.log('Pattern repeat: ' + patternRepeat);
        console.log('Match factor: ' + matchFactor);
        console.log('Number of drops: ' + numberOfDrops);
        console.log('Length of drop: ' + lengthOfDrop);
        console.log('Drops per roll: ' + dropsPerRoll);
        console.log('Total rolls: ' + totalRollsForWall);
        console.log('-----')

        totalRollsForAllWalls += totalRollsForWall;
      }

       
    });
   document.querySelector('input[name="quantity"]').value = totalRollsForAllWalls;
    return totalRollsForAllWalls;
 
};


function validateFloatField(selector) {
    const element = document.querySelector(selector);
    return !isNaN(parseFloat(element.value)) && isFinite(element.value);
}

function validateStringField(selector) {
    const element = document.querySelector(selector);
    return element.value.trim().length > 0;
}

function getFloatFieldValue(selector) {
    const element = document.querySelector(selector);
    return parseFloat(element.value);
}

function getStringFieldValue(selector) {
    const element = document.querySelector(selector);
    return element.value.trim();
}

function getMatchFactor(matchFactorString) {
    // Assuming matchFactor is returned as a string that needs to be parsed
    return parseFloat(matchFactorString);
}

function getWallDimensions() {
   
    return [
        { width: 100, height: 200 },
        { width: 120, height: 250 }
    ];
}




